/* app/js/src/components/clipping-studio/panels/destination-tab/facebook-publish-settings/clipping-studio-facebook-publish-settings.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.facebook-settings {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.facebook-settings__label {
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 10px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.54);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.facebook-settings__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.facebook-settings__dropdown {
  width: 100%;
}
.facebook-settings__dropdown--category ::ng-deep ul {
  max-height: 126px;
  overflow-y: auto;
}
.facebook-settings__checkbox {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.85);
  --mdc-checkbox-selected-checkmark-color: rgb(255, 255, 255);
  --mdc-checkbox-selected-focus-icon-color: rgb(45, 187, 252);
  --mdc-checkbox-selected-hover-icon-color: rgb(45, 187, 252);
  --mdc-checkbox-selected-icon-color: rgb(45, 187, 252);
  --mdc-checkbox-selected-pressed-icon-color: rgb(45, 187, 252);
}
.facebook-settings__checkbox ::ng-deep .mdc-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.85);
}
.facebook-settings__checkbox ::ng-deep .mdc-checkbox__ripple,
.facebook-settings__checkbox ::ng-deep .mat-mdc-checkbox-ripple,
.facebook-settings__checkbox ::ng-deep .mat-mdc-focus-indicator {
  display: none;
}
.facebook-settings__checkbox.mat-mdc-checkbox-disabled {
  cursor: not-allowed;
}
.facebook-settings__checkbox.mat-mdc-checkbox-disabled ::ng-deep .mdc-label {
  color: rgba(0, 0, 0, 0.35);
}
.facebook-settings__checkbox.mat-mdc-checkbox-disabled ::ng-deep .mdc-checkbox__background {
  border-color: rgb(194, 204, 219) !important;
  background-color: rgb(235, 240, 244) !important;
}
.facebook-settings__helper {
  margin: 0;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
  line-height: 1.4;
}
/*# sourceMappingURL=clipping-studio-facebook-publish-settings.component.css.map */
